import { render, staticRenderFns } from "./MediaViewer.vue?vue&type=template&id=8eda8304&scoped=true&"
import script from "./MediaViewer.vue?vue&type=script&lang=js&"
export * from "./MediaViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eda8304",
  null
  
)

export default component.exports